"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20025ToJSON = exports.InlineResponse20025FromJSONTyped = exports.InlineResponse20025FromJSON = void 0;
function InlineResponse20025FromJSON(json) {
    return InlineResponse20025FromJSONTyped(json, false);
}
exports.InlineResponse20025FromJSON = InlineResponse20025FromJSON;
function InlineResponse20025FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rank': json['rank'],
    };
}
exports.InlineResponse20025FromJSONTyped = InlineResponse20025FromJSONTyped;
function InlineResponse20025ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rank': value.rank,
    };
}
exports.InlineResponse20025ToJSON = InlineResponse20025ToJSON;
